import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';

import FormSelect from '../../../components/form/FormSelect';
import FormInput from '../../../components/form/FormInput';

import { processAllOptionGet } from '../../../store/slices/tenantSlices/dailyReportSlice';
import { processCopy } from '../../../store/slices/tenantSlices/configurationSlice';

const CopyProcessModal = ({ isOpen, onCloseClick }) => {
  const dispatch = useDispatch();
  const [processOptions, setProcessOptions] = useState([]);

  const initialValues = {
    source_process_id: '',
    target_process_name: ''
  };

  const validationSchema = Yup.object({
    source_process_id: Yup.string().required('Source Process is required'),
    target_process_name: Yup.string().required('Target Process Name is required')
  });

  const onSubmit = async (values) => {
    try {
      const payload = { ...values };
      const response = await dispatch(processCopy(payload)).unwrap();
      if (response && response?.success) {
        toast.success(response?.message || 'Process copied successfully');
        onCloseClick(true);
        resetForm();
      } else {
        toast.error(response?.message || 'Error copying process');
      }
    } catch (error) {
      console.log('error', error);
      toast.error('Something went wrong');
    }
  };

  const { values, handleChange, handleBlur, handleSubmit, touched, errors, resetForm } = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  const getProcessOption = async () => {
    try {
      const response = await dispatch(processAllOptionGet()).unwrap();
      if (response && response.data) {
        const options = response.data.map((val) => ({
          label: val.name,
          value: val.id
        }));
        setProcessOptions(options);
      } else {
        setProcessOptions([]);
      }
    } catch (error) {
      setProcessOptions([]);
      console.log('error', error);
    }
  };

  useEffect(() => {
    getProcessOption();
  }, []);

  return (
    <Modal isOpen={isOpen} size="lg" centered>
      <ModalHeader className="justify-content-center py-2">
        <div className="fs-5">{'Copy Process'}</div>
      </ModalHeader>
      <ModalBody className="px-4">
        <form id="copy-process" onSubmit={handleSubmit}>
          <Row>
            <Col lg="6">
              <FormSelect
                name="source_process_id"
                label="Source Process"
                placeholder="Select Source Process"
                value={values.source_process_id}
                options={processOptions}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
                menuPlacement="bottom"
              />
            </Col>
            <Col lg="6">
              <FormInput
                name="target_process_name"
                label="Target Process Name"
                placeholder="Enter Target Process Name"
                value={values.target_process_name}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            onCloseClick();
            resetForm();
          }}
          className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button form="copy-process" type="submit" className="px-5 bg-primary border-primary">
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

CopyProcessModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseClick: PropTypes.func
};

export default CopyProcessModal;
